import ErrorBoundary from '@ms/yammer-libs-error-boundary';
import type { FC, NamedExoticComponent } from 'react';
import React, { memo } from 'react';

import PageTelemetryContextProvider from '../PageTelemetryContextProvider';

import AppPageRoutesWithTelemetry from './AppPageRoutesWithTelemetry';
import type { AppPageRoutesWithTelemetryProps } from './AppPageRoutesWithTelemetry.types';

const AppPageRoutesWithTelemetryBoundaryBase: FC<AppPageRoutesWithTelemetryProps> = (props) => (
  <ErrorBoundary name="AppPageRoutesWithTelemetry">
    <PageTelemetryContextProvider>
      <AppPageRoutesWithTelemetry {...props} />
    </PageTelemetryContextProvider>
  </ErrorBoundary>
);

const AppPageRoutesWithTelemetryBoundary: NamedExoticComponent<AppPageRoutesWithTelemetryProps> = memo(
  AppPageRoutesWithTelemetryBoundaryBase
);
export default AppPageRoutesWithTelemetryBoundary;
